<template>
  <v-alert
    :value="show"
    dismissible
    type="warning"
    color="warning"
    @input="closeNote"
    transition="scale-transition"
  >
    <p>
      Der TARMED Validator befindet sich in der Beta-Phase. Es können Ungenauigkeiten bei der
      Validierung sowie Änderungen der Funktionen auftreten.
    </p>
    <v-divider class="mb-3"></v-divider>
    <p class="mb-0">
      Die Ergebnisse der Validierung stellen keine Empfehlung zur Abrechnung dar. Bitte lesen Sie die
      <a href="/de/hinweise" target="_new">Hinweise zur Validierung</a> aufmerksam durch.
    </p>
  </v-alert>
</template>

<script>

import Cookie from "js-cookie"

export default {
  data() {
    return {
      show: false
    }
  },
  mounted() {
    if (!Cookie.get("tv_vnShown")) {
      this.show = true
    }
  },
  methods: {
    closeNote() {
      Cookie.set("tv_vnShown", true)
    }
  }
}
</script>

<style scoped>
a {
  color: #fff;
}
</style>
